export function isIOS(): boolean {
  return /iPad|iPhone|iPod/.test(navigator.userAgent)
}

export function isIOSChrome(): boolean {
  return /CriOS/.test(navigator.userAgent)
}

/**
 * Returns true when the user is on iOS AND using Safari (not Chrome/Firefox/etc).
 * Safari on iOS does not support WebM video, so .mov / .mp4 files should be used instead.
 */
export function isIOSSafari(): boolean {
  const ua = navigator.userAgent
  const isIOSDevice = /iPad|iPhone|iPod/.test(ua)
  // Safari identifies itself with 'Safari' but NOT 'CriOS', 'FxiOS', or 'OPiOS'
  const isSafari = /Safari/.test(ua) && !/CriOS|FxiOS|OPiOS|EdgiOS/.test(ua)
  return isIOSDevice && isSafari
}
